import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.27576 9.28383L7.99311 5.19152L12.7104 9.22495C12.7911 9.30346 12.9423 9.34272 13.164 9.34272C13.3656 9.34272 13.537 9.28383 13.6781 9.16607C13.9402 8.87166 13.92 8.57725 13.6176 8.28284L7.99311 3.57227L2.36858 8.34172C2.08635 8.65576 2.06619 8.95017 2.3081 9.22495C2.59034 9.48011 2.91289 9.49973 3.27576 9.28383Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.7242 11.0804L8.00689 15.1727L3.28955 11.1393C3.20891 11.0608 3.05772 11.0215 2.83596 11.0215C2.63437 11.0215 2.46301 11.0804 2.32189 11.1982C2.05982 11.4926 2.07998 11.787 2.38237 12.0814L8.00689 16.792L13.6314 12.0225C13.9137 11.7085 13.9338 11.4141 13.6919 11.1393C13.4097 10.8842 13.0871 10.8645 12.7242 11.0804Z",
		fill: "currentColor"
	})]
});
export default SvgArrowUpDown;
